var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComponentTicketIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.502 5.4375C14.8305 5.14584 15.1111 5 15.4347 5C16.0456 5 16.5036 5.51983 17.4197 6.55949L19.6726 9.11642C20.8909 10.4991 21.5 11.1904 21.5 12C21.5 12.8096 20.8909 13.5009 19.6726 14.8836L17.4197 17.4405C16.5036 18.4802 16.0456 19 15.4347 19C15.1111 19 14.8305 18.8541 14.502 18.5625",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1205 6.55949C9.04557 5.51983 9.50812 5 10.125 5C10.7419 5 11.2044 5.51983 12.1295 6.55949L14.4046 9.11642C15.6349 10.4991 16.25 11.1904 16.25 12C16.25 12.8096 15.6349 13.5009 14.4046 14.8836L12.1295 17.4405C11.2044 18.4802 10.7419 19 10.125 19C9.50812 19 9.04557 18.4802 8.1205 17.4405L5.84539 14.8836C4.61513 13.5009 4 12.8096 4 12C4 11.1904 4.61513 10.4991 5.84539 9.11642L8.1205 6.55949Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponentTicketIc);
export default __webpack_public_path__ + "static/media/component_ticket_ic.e6f9acf829573dd0994579716bd60cc2.svg";
export { ForwardRef as ReactComponent };